import React from 'react';
import Breadcrumb from '../../../components/Breadcrumb';
import { SOCIETY_CONTROLLER, SOCIETY_MANAGE_USERS } from '../../../Routing/routes';
import ManageUsersListLayer from './Component/ManageUsersListLayer';

const ManageUsers = () => {
    const links = [
        { to: SOCIETY_CONTROLLER, text: 'Dashboard' },
        { to: SOCIETY_MANAGE_USERS, text: 'Manage Users' }
    ];

    return (
        <>
            <Breadcrumb
                description='View and manage all users in the system'
                links={links}
                headingTitle="Manage User"
            />
            <ManageUsersListLayer />
        </>
    );
};

export default ManageUsers;
